'use strict';

{
	//告知バー表示判定

	if (document.querySelector('.announcement-bar-section') !== null) {
		document.body.classList.add('announcement-bar-true');
	}

	//ページ内リンクのときハンバーガーメニューを閉じる
	const hamburger = document.querySelector('#Details-menu-drawer-container');
	const hamburgerSummary = document.querySelector('.header__icon--menu');
	const anchorLinks = document.querySelectorAll('a.index');
	anchorLinks.forEach(function (item) {
		item.addEventListener('click', function () {
			document.body.classList.remove('overflow-hidden-tablet');
			hamburger.removeAttribute('open');
			hamburgerSummary.setAttribute('aria-expanded', 'false');
		})
	});
}